<div class='container customer-container mt-2'>
	<h3 class='mt-2 mb-4'>{{ 'ndg.insert.title' | translate }}</h3>
	<form [formGroup]="formGroup" autocomplete="off" (ngSubmit)="onSubmit()">
        <!-- TYPE -->
        <insert-edit-dropdown fieldName="type" label="ndg.type" [domain]="typologyList" [required]="true"></insert-edit-dropdown>
        
        <div *ngIf="type?.value">
            <!-- FISICAL PERSON -->
            <div *ngIf="isFisical(type?.value)">
                <!-- NAME -->
                <insert-edit-string fieldName="name" label="ndg.name" [required]="true"></insert-edit-string>

                <!-- SURNAME -->
                <insert-edit-string fieldName="surname" label="ndg.surname" [required]="true"></insert-edit-string>

                <!-- FISCAL CODE -->
                <insert-edit-string fieldName="fiscalCode" label="ndg.fiscal-code" [required]="true" [uppercase]="true"></insert-edit-string>
    
                <!-- CITY -->
                <insert-edit-autocomplete fieldName="city" label="ndg.city" [domain]="cityListDomain" (selected)="onCitySelected($event)" [required]="true"></insert-edit-autocomplete>
    
                <!-- CAP -->
                <insert-edit-string fieldName="cap" label="ndg.cap" [required]="true"></insert-edit-string>

                <!-- ADDRESS -->
                <insert-edit-string fieldName="address" label="ndg.address" [required]="true"></insert-edit-string>

                <!-- EMAIL -->
                <insert-edit-string fieldName="email" label="ndg.email"></insert-edit-string>

                <!-- PHONE -->
                <insert-edit-string fieldName="phone" label="ndg.phone"></insert-edit-string>
            </div>

            <!-- GIURIDIC PERSON -->
            <div *ngIf="isGiuridical(type?.value)">
                <!-- DESCRIPTION -->
                <insert-edit-string fieldName="description" label="ndg.description" [required]="true"></insert-edit-string>
    
                <!-- VAT NUMBER -->
                <insert-edit-string fieldName="vatNumber" label="ndg.vat-number" [required]="true"></insert-edit-string>
    
                <!-- CITY -->
                <insert-edit-autocomplete fieldName="city" label="ndg.city" [domain]="cityListDomain" (selected)="onCitySelected($event)" [required]="true"></insert-edit-autocomplete>
    
                <!-- CAP -->
                <insert-edit-string fieldName="cap" label="ndg.cap" [required]="true"></insert-edit-string>

                <!-- ADDRESS -->
                <insert-edit-string fieldName="address" label="ndg.address" [required]="true"></insert-edit-string>

                <!-- DATE START ACTIVITY -->
                <insert-edit-date fieldName="dateStartActivity" label="ndg.start-activity" [required]="true"></insert-edit-date>

                <!-- EMPLOYEES -->
                <insert-edit-dropdown fieldName="employees" label="ndg.employees.label" [domain]="employeesList" [required]="true"></insert-edit-dropdown>
			
                <div class='form-group row mt-3'>
                    <label class='col-12 col-form-label'>Prosegui a compilare il questionario inserendo i dati del legale rappresentante</label>
                </div>

                <!-- NAME -->
                <insert-edit-string fieldName="name" label="ndg.name" [required]="true"></insert-edit-string>

                <!-- SURNAME -->
                <insert-edit-string fieldName="surname" label="ndg.surname" [required]="true"></insert-edit-string>

                <!-- FISCAL CODE -->
                <insert-edit-string fieldName="fiscalCode" label="ndg.fiscal-code" [required]="true" [uppercase]="true"></insert-edit-string>
            </div>
        </div>
	
        <button class='btn btn-primary mb-4 mt-3' [disabled]="loading || disabled">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ "ndg.insert.submit" | translate }}
        </button>
    </form>
</div>
